import * as React from 'react';

import { translate } from '~l10n/client';
import cx from 'classnames';

import { useTrueFalseValue } from './hooks';

interface Props {
  answerIds: Array<string | number>;
}

const QuestionTrueFalseDisplayAnswer: React.FunctionComponent<Props> = ({
  answerIds,
}: React.PropsWithChildren<Props>) => {
  const { value } = useTrueFalseValue({ answerIds, isEditing: false });
  const answerClass = cx(
    'p-3 rounded-1 font-sans text-base font-600 leading-base text-white text-center',
    {
      'bg-green-500': value === true,
      'bg-red-500': value === false,
    }
  );

  return (
    <div className={answerClass}>
      {value === true ? translate('True') : translate('False')}
    </div>
  );
};

export default QuestionTrueFalseDisplayAnswer;
